import { render, staticRenderFns } from "./CommissionProfileForm.vue?vue&type=template&id=8a97a284&scoped=true"
import script from "./CommissionProfileForm.vue?vue&type=script&lang=js"
export * from "./CommissionProfileForm.vue?vue&type=script&lang=js"
import style0 from "./CommissionProfileForm.vue?vue&type=style&index=0&id=8a97a284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_40df3e800382af9a7a59c1fe33ba5098/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a97a284",
  null
  
)

export default component.exports